import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  Input,
  OnChanges,
  SimpleChanges,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  HostListener,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
} from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
  DAYS_OF_WEEK,
  CalendarEventTitleFormatter,
} from 'angular-calendar';
import { CustomEventTitleFormatter } from './custom-event-title-formatter.provider';
import { EventColor } from 'calendar-utils';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { LOCALE_ID } from '@angular/core';
import { LabelService } from '../../services/label.service';
import { DoctorService } from '../../services/doctor.service';
import { CalendarGoogle } from '../../models/doctor-model';

@Component({
  selector: 'app-calendar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  templateUrl: './calendar.component.html',
  providers: [
    {
      provide: CalendarEventTitleFormatter,
      useClass: CustomEventTitleFormatter,
    },
  ],
  styleUrl: './calendar.component.scss',
})
export class CalendarComponent implements OnInit, OnChanges, AfterViewInit {
  // @Input() allEvents: any[] = [];
  @Input() events: CalendarEvent[] = [];
  @Input() calendars: CalendarGoogle[] = [];
  @Output() newCalendarEvent = new EventEmitter<any>();
  @Output() calendarEventClicked = new EventEmitter<CalendarEvent>();
  @Output() synchAppointments = new EventEmitter<void>();

  @ViewChild('modalContent', { static: true }) modalContent:
    | TemplateRef<any>
    | undefined;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLElement>;
  locale = 'it-IT';
  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  isMobile = window.innerWidth < 930;
  view: CalendarView = this.isMobile ? CalendarView.Month : CalendarView.Week;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  modalData:
    | {
        action: string;
        event: CalendarEvent;
      }
    | undefined;
  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];
  refresh = new Subject<void>();
  //events: CalendarEvent[] = [];
  activeDayIsOpen: boolean = false;
  dayStartHour: number = 0;
  dayEndHour: number = 23;

  showAddEventPanel: boolean = false;
  showCalendarsGoogle: boolean = false;

  constructor(
    private modal: NgbModal,
    public labelService: LabelService,
    private doctorService: DoctorService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.refresh.next();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.refresh.next();
  }

  ngAfterViewInit() {
    this.scrollToCurrentView();
  }

  private scrollToCurrentView() {
    if (this.view === CalendarView.Week) {
      setTimeout(() => {
        // 8 hours * 44 is the height of each hour line
        this.scrollContainer.nativeElement.scrollTop = 8 * 44;
      }, 0); // Esegue dopo il ciclo di rendering
    }
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    let newEvent: CalendarEvent<any> = { start: new Date(), title: '' };
    newEvent = {
      ...event,
      start: newStart,
      end: newEnd,
    };
    this.handleEvent('Dropped or resized', newEvent);
    // if (!this.areEventsOnSameDay(event, newEvent)) {
    // }
  }

  // areEventsOnSameDay(event1: CalendarEvent, event2: CalendarEvent): boolean {
  //   const start1 = event1.start;
  //   const start2 = event2.start;

  //   // Confronta anno, mese e giorno dei due eventi
  //   return (
  //     start1.getFullYear() === start2.getFullYear() &&
  //     start1.getMonth() === start2.getMonth() &&
  //     start1.getDate() === start2.getDate()
  //   );
  // }

  handleEvent(action: string, event: CalendarEvent): void {
    if (event) {
      this.calendarEventClicked.emit(event);
    }
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
    this.scrollToCurrentView();
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  hourClickedInWeekView(event?: any) {
    if (event) {
      this.newCalendarEvent.emit(event);
    } else {
      this.newCalendarEvent.emit();
    }
  }

  showCalendars() {
    this.showCalendarsGoogle = !this.showCalendarsGoogle;
  }

  synchronizeAppointments() {
    this.synchAppointments.emit();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 930;
    this.view = this.isMobile ? CalendarView.Month : CalendarView.Week;
  }
}
